/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { NotificationPreference } from "../models/notificationPreference";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Save Notification Preference
 */
export const saveNotificationPreference = (
  notificationPreference: NotificationPreference,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<string>(
    {
      url: `/api/notification/preferences`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: notificationPreference,
      signal,
    },
    options,
  );
};

export const getSaveNotificationPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveNotificationPreference>>,
    TError,
    { data: NotificationPreference },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveNotificationPreference>>,
  TError,
  { data: NotificationPreference },
  TContext
> => {
  const mutationKey = ["saveNotificationPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveNotificationPreference>>,
    { data: NotificationPreference }
  > = (props, context) => {
    const { data } = props ?? {};

    return saveNotificationPreference(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveNotificationPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveNotificationPreference>>
>;
export type SaveNotificationPreferenceMutationBody = NotificationPreference;
export type SaveNotificationPreferenceMutationError = ErrorType<unknown>;

/**
 * @summary Save Notification Preference
 */
export const useSaveNotificationPreference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveNotificationPreference>>,
      TError,
      { data: NotificationPreference },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveNotificationPreference>>,
  TError,
  { data: NotificationPreference },
  TContext
> => {
  const mutationOptions = getSaveNotificationPreferenceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Notification Preference
 */
export const findNotificationPreference = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<NotificationPreference>(
    { url: `/api/notification/preferences`, method: "GET", signal },
    options,
  );
};

export const getFindNotificationPreferenceQueryKey = () => {
  return [`/api/notification/preferences`] as const;
};

export const getFindNotificationPreferenceQueryOptions = <
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof findNotificationPreference>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindNotificationPreferenceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findNotificationPreference>>
  > = ({ signal, meta }) =>
    findNotificationPreference({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findNotificationPreference>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindNotificationPreferenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof findNotificationPreference>>
>;
export type FindNotificationPreferenceQueryError = ErrorType<unknown>;

export function useFindNotificationPreference<
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotificationPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotificationPreference>>,
          TError,
          Awaited<ReturnType<typeof findNotificationPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotificationPreference<
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotificationPreference>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotificationPreference>>,
          TError,
          Awaited<ReturnType<typeof findNotificationPreference>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotificationPreference<
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotificationPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Notification Preference
 */

export function useFindNotificationPreference<
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotificationPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindNotificationPreferenceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find Notification Preference
 */
export const prefetchFindNotificationPreference = async <
  TData = Awaited<ReturnType<typeof findNotificationPreference>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotificationPreference>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindNotificationPreferenceQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
